import { useState } from "react";
import { ArrowRightLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useWorkspaces } from "@/lib/useWorkspaces";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const CopyToChannelButton = ({ endpoint, itemName, testId, note }) => {
  const { user } = useAuth();
  const { others } = useWorkspaces();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);
  if (user?.role !== "admin" || others.length === 0) return null;

  const copy = async (ws) => {
    setBusy(ws.id);
    try {
      const r = await api.post(endpoint, { workspace_id: ws.id });
      toast.success(`«${r.data.name}» copiato nel canale ${r.data.workspace_name}`);
      setOpen(false);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(null);
  };

  return (
    <>
      <button onClick={() => setOpen(true)} data-testid={testId} className="text-slate-400 hover:text-[#1E4FD8] p-1" title="Copia in un altro canale">
        <ArrowRightLeft className="h-4 w-4" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white border-slate-200 text-slate-800 max-w-md" data-testid="copy-to-channel-dialog">
          <DialogHeader>
            <DialogTitle>Copia in un altro canale</DialogTitle>
            <DialogDescription>«{itemName}» verrà copiato nel canale scelto. {note}</DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            {others.map((w) => (
              <Button key={w.id} variant="outline" disabled={!!busy} onClick={() => copy(w)} data-testid={`copy-to-channel-${w.id}`}
                      className="w-full justify-start border-slate-200 h-11">
                <span className="h-2.5 w-2.5 rounded-full mr-3" style={{ backgroundColor: w.color }} />
                <span className="flex-1 text-left truncate">{w.name}</span>
                {busy === w.id && <Loader2 className="h-4 w-4 animate-spin" />}
              </Button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
